/**
 * @file: 运营活动页面
 * @author: wence
 */
import React, {PureComponent} from 'react';
import cn from 'classnames';
import PropType from 'prop-types';
import {connect} from 'react-redux';

import './index.less';
import {
    fetchGetNewService,
    fetchInstanceGetInstance,
    fetchApimealPay,
    fetchRealName
} from '../../actions/buyAction';

import confirmBox from '../../components/Confirmation';
import {fetchActivityInfo, fetchRemain, fetchPrize} from '../../actions/activityAction';
import {payVoucher} from '../../actions/activitySuAction';
import FromModal from './modal';
import {bAntiBotSend} from '../../util';

export const flag = 'saasact4';

const renderBody = (content, title, disabledHtml) => {
    return (
        <div className="w-prize-body">
            <div className="title">
                {title}
            </div>
            {disabledHtml
                ? <div className="content">{content}</div>
                : <div className="content" dangerouslySetInnerHTML={{__html: content}}/>}
        </div>
    );
};

const renderFooter = ({okText, okClick, cancelText, cancelClick}) => {
    return (
        <div className="x-footer">
            {cancelText
            && <div onClick={cancelClick} className="x-btn x-footer-cancel">
                {cancelText}
            </div>}
            {okText
            && <div onClick={okClick} className="x-btn x-footer-confirm">
                {okText}
            </div>}
        </div>
    );
};

renderFooter.propTypes = {
    okText: PropType.string,
    okClick: PropType.func,
    cancelText: PropType.string,
    cancelClick: PropType.func
};

export const confirm = ({
    title,
    type,
    content,
    okText,
    okClick,
    cancelText,
    cancelClick,
    disabledHtml,
    isAnimation,
    disableCloseByMask
}) => {
    return confirmBox({
        title,
        isAnimation,
        disableCloseByMask,
        className: cn('w-confirm-modal', type),
        renderBody: () => renderBody(content, title, disabledHtml),
        renderFooter: () => renderFooter({
            okText,
            okClick,
            cancelText,
            cancelClick
        })
    });
};

class Activity extends PureComponent {
    static propTypes = {
        fetchGetNewService: PropType.func,
        fetchInstanceGetInstance: PropType.func,
        fetchApimealPay: PropType.func,
        instanceGetinstance: PropType.object,
        activityGetService: PropType.object
    };

    constructor(props) {
        super(props);

        this.state = {
            instanceRes: {},
            serviceList: [],
            orderList: [],
            activityInfo: {},
            remain: 0,
            prizeIndex: -1, // 中奖位置
            visible: false,
            parizeInfo: null,
            isStart: false,
            remainMsg: ''
        };

        this.instanceId = '';
        this.speed = 30;
        this.inter = false;
        this.timer = null;
        this.index = 0;
        this.endIndex = -1;
        this.circle = 30;
        this.prizeCount = 0;
        this.start = false;

        if (this.isPC()) {
            location.href = '/activity/prize';
        }
    }

    async componentDidMount() {
        const {fetchInstanceGetInstance} = this.props;
        const instanceRes = await fetchInstanceGetInstance();

        if (instanceRes.data && instanceRes.data.status === 0) {
            this.instanceId = Object.keys(instanceRes.data.data)[0];
        }

        await this.fetchActivityInfo();
        await this.fetchRemainInfo();

        this.fetchGetNewService();

        this.setState({
            instanceRes: instanceRes ? instanceRes.data : {}
        });
    }

    fetchActivityInfo = async () => {
        const res = await fetchActivityInfo({flag, 'is_wap': 1});

        if (res.status === 0) {
            this.setState({activityInfo: res.data});

            const prize = (res.data && res.data.prize || []).length;

            this.prizeCount = prize;

            this.setState({
                isStart: res.data.start
            });
        } else {
            this.setState({activityInfo: {}});
        }
    };

    fetchGetNewService = async () => {
        const fetchGetNewService = this.props.fetchGetNewService;
        const newService = await fetchGetNewService(
            this.instanceId
                ? {'instance_id': this.instanceId}
                : undefined
        );
        if (newService.data && newService.data.status === 0) {
            this.setState({
                serviceList: newService.data.data.free_list,
                orderList: newService.data.data.order_list,
            });
        }
    };

    payVoucher = async () => {
        const params = {
            'instance_id': this.instanceId,
            'channel': '1'
        };

        try {
            const localKey = '__abbaidu_20181211_cb';
            const dataStr = localStorage.getItem(localKey);
            const data = JSON.parse(dataStr);
            params.data = data.data;
            params['key_id'] = data.key_id;
            params.sign = data.sign;
        } catch (e) {
            params.data = '';
            params['key_id'] = '';
            params.sign = '';
        }

        const res = await payVoucher(params);

        if (res.status === 0) {
            this.confirm = confirm({
                title: '领取成功！',
                content: `<div class="lq-success">
                <div class="lq-item"><span>100</span><span>元</span><span>漏洞扫描-专业版 月套餐专用</span></div>
                <div class="lq-item"><span>300</span><span>元</span><span>漏洞扫描-专业版 年套餐专用</span></div>
                <div class="lq-item"><span>4000</span><span>元</span><span>网址安全检测 A套餐专用</span></div>
                <div class="lq-item"><span>5400</span><span>元</span><span>网址安全检测 B套餐专用</span></div>
            </div>
            <div class="lq-hint">
            发放至账户，可在<a target="_blank" href="/console/#/orderView">个人中心</a>查看
            </div>`,
                okText: '去购买',
                okClick: () => {
                    window.location.href = '/console/#/urlsec/buy';
                }
            });
        } else if (res.status === 401) {
            window.location.href = this.loginUrl();
        } else if (res.description) {
            this.confirm = confirm({
                title: '',
                content: res.description,
                okText: '关闭',
                isAnimation: false,
                okClick: () => this.confirm && this.confirm()
            });
        }
    };

    payProduct = item => {
        if (item.is_buy) {
            return false;
        }
        const {instanceRes, serviceList} = this.state;

        if (serviceList.length && instanceRes.status === 0) {
            let json = {
                'instance_id': this.instanceId,
                'service_id': item.service_id,
                'meal_id': item.meal_id
            };

            this.props.fetchApimealPay(json).then(data => {
                if (data.data.status === 0) { // 购买成功
                    this.fetchGetNewService();
                    this.fetchRemainInfo();
                    this.confirm = confirm({
                        title: '',
                        type: 'small',
                        content: '购买成功，可前往控制台查看使用说明',
                        okText: '继续购买',
                        okClick: () => {
                            this.confirm && this.confirm();
                        },
                        cancelText: '去控制台',
                        cancelClick: () => {
                            window.location.href = item.url;
                        }
                    });
                } else if (data.data.status === 404008) { // 未实名
                    fetchRealName({'instance_id': this.instanceId}).then(res => {
                        this.confirm = confirm({
                            title: '',
                            type: 'small',
                            content: '您的账号还没有认证，认证后才能购买哦！',
                            okText: '去认证',
                            okClick: () => {
                                window.location.href = (res && res.data && res.data['auth_type'] === 1)
                                    ? '/console/#/attestation'
                                    : this.userCenterUrl();
                            }
                        });
                    });
                } else if (data.data.status === 404008) { // 未登录
                    location.href = this.loginUrl();
                } else {
                    this.confirm = confirm({
                        title: '',
                        content: data.data.description,
                        okText: '确认',
                        okClick: () => {
                            this.confirm && this.confirm();
                        }
                    });
                }
            });
        } else {
            location.href = this.loginUrl();
        }
    };

    getActivityId = () => {
        return ((this.state.activityInfo || {}).activity || {}).activity_id;
    };

    fetchRemainInfo = async () => {
        const res = await fetchRemain({aid: this.getActivityId(), flag, 'instance_id': this.instanceId});

        if (res.status === 0) {
            this.setState({remain: res.data.remain, remainMsg: ''});
        } else {
            this.setState({remainMsg: res.description});
        }
    };

    getPrize = async () => {
        if (!this.state.isStart) {
            this.confirm = confirm({
                title: '',
                content: '您好，不在活动时间范围内哦',
                okText: '确认',
                okClick: () => {
                    this.confirm && this.confirm();
                }
            });

            return;
        }

        if (this.start) {
            return;
        }

        this.start = true;

        let params = {aid: this.getActivityId(), flag, 'instance_id': this.instanceId};

        bAntiBotSend();
        window['__abbaidu_2024_cb'] = async responseData => {
            let localData = JSON.parse(responseData);
            if (localData && localData.data) {
                params.data = localData.data;
            }
            if (localData && localData.key_id) {
                params['key_id'] = localData['key_id'];
            }
            if (localData && localData.sign) {
                params.sign = localData.sign;
            }

            const res = await fetchPrize(params);
            if (res.status === 0) {
                if (!res.data.status) {
                    this.start = false;

                    if (res.data.code === 10003) {
                        this.makeTask(res.data.message);
                        return;
                    }

                    if (res.data.code === 10004) {
                        this.setState({remain: res.data.remain || 0});
                        this.startRoll();
                        this.interRoll(res.data);
                        this.stopRoll(-1);
                        return;
                    }

                    this.confirm = confirm({
                        title: '',
                        content: res.data.message,
                        okText: '确认',
                        okClick: () => {
                            this.confirm && this.confirm();
                        }
                    });
                    return;
                }
                this.setState({remain: res.data.remain || 0});
                this.startRoll();
                this.interRoll(res.data);
                if (res.data.prize && res.data.prize.pid) {
                    const prizeList = this.state.activityInfo.prize || [];
                    const index = prizeList.findIndex(item => item.pid === res.data.prize.pid);
                    this.stopRoll(index);
                } else {
                    this.stopRoll(-1);
                }
            } else if (res.status === 401) {
                this.start = false;
                this.confirm = confirm({
                    title: '',
                    content: res.description,
                    okText: '去登录',
                    okClick: () => {
                        this.confirm && this.confirm();
                        window.location.href = this.loginUrl();
                    }
                });
            } else {
                this.start = false;
                this.confirm = confirm({
                    title: '',
                    content: res.description,
                    okText: '确认',
                    okClick: () => {
                        this.confirm && this.confirm();
                    }
                });
            }
        };
    };

    makeTask = text => {
        this.confirm = confirm({
            title: '',
            content: text,
            okText: '去参加',
            okClick: () => {
                this.confirm && this.confirm();
                const offsetTop = this.productNode.getBoundingClientRect().top;
                document.documentElement.scrollTop = document.body.scrollTop = offsetTop;
            }
        });
    };

    successRoll = () => {
        this.start = false;
        if (!this.info) {
            return;
        }
        const info = this.info;
        if (info.status && info.prize && info.prize.prize_type === 1) {
            this.confirm = confirm({
                title: '',
                content: '恭喜您获得' + info.prize.prize_name + '一个，请填写邮寄信息',
                okText: '填写信息',
                cancelText: '继续抽奖',
                okClick: () => {
                    this.setState({visible: true, parizeInfo: info}, () => {
                        this.confirm && this.confirm();
                    });
                },
                cancelClick: () => {
                    this.confirm && this.confirm();
                }
            });
        } else if ((info && info.prize && info.prize.prize_name)) {
            this.confirm = confirm({
                title: '',
                content: info.message
                    || '恭喜您中奖' + info.prize.prize_name
                    + '，请前往<a '
                    + 'target="_blank"'
                    + 'href="/console/#/orderView">控制台</a>查看使用',
                okText: this.state.remain > 0 ? '继续抽奖' : '确认',
                okClick: () => {
                    this.confirm && this.confirm();

                    // if (this.state.remain === 0) {
                    //     const offsetTop = this.productNode.offsetTop;
                    //     document.documentElement.scrollTop = document.body.scrollTop = offsetTop;
                    // }
                }
            });
        } else if (info && info.message) {
            this.confirm = confirm({
                title: '',
                content: info.message,
                okText: '确认',
                okClick: () => {
                    this.confirm && this.confirm();
                }
            });
        }

        this.setState({prizeIndex: -1});
    };

    startRoll = () => {
        this.speed += 10;
        if (!this.inter && this.speed > 50) {
            this.speed = 50;
        }

        if (this.speed >= 100) {
            this.speed = 100;
        }

        if (this.circle <= 0 && this.endIndex === this.state.prizeIndex) {
            clearTimeout(this.timer);
            this.timer = null;
            this.initalCountParams();
            this.successRoll();
            return;
        }

        if (this.circle <= 0 && this.endIndex === -1) {
            clearTimeout(this.timer);
            this.timer = null;
            this.initalCountParams();
            this.successRoll();
            this.setState({prizeIndex: -1});
            return;
        }

        this.circle -= 1;
        if (!this.inter && this.circle <= 10) {
            this.circle = 10;
        }

        this.setState({prizeIndex: this.index}, () => {
            if (this.index >= this.prizeCount - 1) {
                this.index = 0;
            } else {
                this.index += 1;
            }
            setTimeout(this.startRoll, this.speed);
        });
    };

    interRoll = info => {
        this.inter = true;
        this.info = info;
    };

    stopRoll = index => {
        this.endIndex = index || -1;
    };

    setPrizeCount = count => {
        this.prizeCount = count;
    };

    initalCountParams = () => {
        this.speed = 30;
        this.inter = false;
        this.timer = null;
        this.index = -1;
        this.endIndex = -1;
        this.circle = 30;
    };

    render() {
        const prizeList = [0, 1, 2, 7, -1, 3, 6, 5, 4];
        const {serviceList, activityInfo, visible, parizeInfo, orderList} = this.state;
        const activity = activityInfo && activityInfo.activity || {};
        let obj = {
            ent: '企业版',
            adv: '专业版',
            free: '免费版'

        };
        return (
            <div className="w-activity">
                <div className={'pic1'}/>
                <div className={'pic2'}/>
                <div className={'pic3'}/>
                <FromModal
                    aid={this.getActivityId()}
                    resetData={() => null}
                    visible={visible}
                    successMsg={'信息提交成功, 详细信息请到我的奖品中查看~'}
                    parizeInfo={parizeInfo && parizeInfo.prize}
                    onCancel={() => this.setState({visible: false, parizeInfo: null})}/>
                <div className="w-activity-banner"></div>
                <div className="w-section-title padding-top-100" style={{display: 'none'}}>
                    <h3 className="w-section-title-text">{activity.activity_name}</h3>
                </div>
                <h4 className="w-section-sub-title">{activity.activity_desc}</h4>
                <div className="w-prize-wrapper">
                    <div className="w-prize">
                        {prizeList.map(index => {
                            if (index === -1) {
                                return (
                                    <div key={index} onClick={this.getPrize} className="w-prize-btn">
                                        <span className="prize">立即抽奖</span>
                                        {this.state.instanceRes.status === 0
                                        && <span className="count">
                                            {`剩余${this.state.remain}次抽奖机会`}
                                        </span>
                                        }
                                    </div>
                                );
                            }
                            const info = (activityInfo.prize || [])[index] || {};
                            const imgUrl = info.prize_img_url ? `url(${info.prize_img_url})` : '';
                            return (
                                <div
                                    key={index}
                                    className={cn('w-prize-cell', {active: this.state.prizeIndex === index})}>
                                    <div
                                        className="pic"
                                        style={{backgroundImage: imgUrl}}/>
                                    <div className="name">{info.prize_name}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="w-rules">
                    <span className="w-rules-content">
                        活动时间：2021年6月9日 - 2021年7月8日<br/>
                        参与方式<br/>
                        {`1、【0元抽大奖】首次领取免费试用或者购买任一付费产品（漏洞扫描专业版/企业版服务、网址安全检测任意付费套餐服
                        务），即可获得三次抽奖机会，每个账户最多三次抽奖机会；`}
                        <br/>
                        2.【新购满额送】成功购买网址安全检测服务的付费套餐，即赠送价值500元的京东礼品卡一张，限量抢购，送完为止。下单成功后，请在
                        <a target="_blank" className="w-linkClassP" href="/activity/address">我的奖品</a>
                        填写邮寄信息。<br/>
                        3、【万元大礼包】所有平台新老用户均可领取万元优惠券大礼包。代金券有效期：2021年6月9日 - 2021年7月8日；<br/>
                        用户抽中实物奖品后，工作人员将会在活动结束后15个工作日内寄送，奖品请在活动期内完成邮寄信息的填写，
                        否则视为自动放弃；用户抽中代金券奖品后，将由系统自动发放至账户，可在
                        <a target="_blank" className="w-linkClassP" href="/console/#/orderView">个人中心</a>查看。
                        代金券有效期：2021年6月9日 - 2021年7月8日；
                    </span>
                    <span className="w-rules-options">
                        <span
                            onClick={() => {
                                this.confirm = confirm({
                                    title: '活动规则',
                                    type: 'large',
                                    content: (
                                        <div className="details-wrapper">
                                            <div className="details">
                                                1.活动时间<br/>
                                                2021年6月9日 - 2021年7月8日<br/>
                                                2.参与条件<br/>
                                                {`1)【0元抽大奖】首次领取免费试用或者购买任一付费产品（漏洞扫描专业版/企业版服务
                                                、网址安全检测任意付费套餐服务），即可获得三次抽奖机会，每个账户最多三次抽奖机会`}<br/>
                                                2)【新购满额送】成功购买网址安全检测服务的付费套餐，即赠送价值500元的京东礼品卡一张，
                                                限量抢购，送完为止。下单成功后，请在
                                                <a target="_blank" className="w-linkClassP" href="/m/activity/address">
                                                    我的奖品</a>
                                                填写邮寄信息。<br/>
                                                3)【万元大礼包】所有平台新老用户均可领取万元优惠券大礼包。系统将自动发放至账户，
                                                可在
                                                <a target="_blank" className="w-linkClassP" href="/console/#/orderView">
                                                    个人中心</a>查看；代金券有效期：2021年6月9日 - 2021年7月8日；<br/>
                                                3. 参与对象<br/>
                                                本次活动仅针对未在本平台领取过免费试用产品的用户，及活动期间成功购买付费版漏洞扫描或网址安全检测服务的用户。<br/>
                                                4.奖品信息<br/>
                                                1)本次抽奖活动的实物奖品有小度智能音箱Pro、度熊桌面加湿器、京东礼品卡50元、京东礼
                                                品卡100元、爱奇艺VIP黄金会员月卡、百度漏洞扫描企业版月套餐优惠券1000元，百度漏洞扫描
                                                企业版年套餐优惠券5000元、小木屋图书·至尊先享月卡，活动总体中奖概率99%。<br/>
                                                2)用户抽中实物奖品后，请在活动期内，即2021年6月9日至2021年7月8日期间在
                                                <a target="_blank" className="w-linkClassP" href="/m/activity/address">
                                                    我的奖品</a>完成邮寄信息的填写，否则视为自动放弃。工作人员将会在活动结束后
                                                15个工作日内寄送奖品。逾期未完成邮寄信息填写或因所提供信息问题导致的错发、
                                                奖品丢失或未收到奖品的，将由用户承担不利后果。<br/>
                                                3)实物奖品图片仅供参考，请以具体实物为准，具体奖品配套及售后服务等，由相应实物
                                                生产和销售商家负责提供，具体见实物奖品配套使用说明书等。用户在收到实物奖品后，
                                                务必第一时间验货。若发现运输途中造成商品损坏，请拒签退回，如确认无误方可签收。
                                                一经签收，奖品毁损灭失百度概不负责。实物奖品无质量问题均不支持退换，奖品均不提
                                                供发票和收据等凭证。<br/>
                                                4)用户抽中代金券等非实物奖品后，将由系统自动发放至用户账户，请通过
                                                <a
                                                    target="_blank"
                                                    className="w-linkClassP"
                                                    href="/console/#/orderView">个人中心</a>查看。
                                                代金券有效期为2021年6月9日 - 2021年7月8日。<br/>
                                                5.特别说明<br/>
                                                1)参与活动的用户应同时遵守百度安全官网所示的《用户服务协议》、 产品相关的协议及页面
                                                使用规则（包括但不限于产品服务等级协议，使用规范，产品服务条款等）。<br/>
                                                2)同一设备仅可登录一个帐号参与活动。活动期间，一经发现通过恶意注册或其他不正当手
                                                段在本次活动中进行非法牟利、炒作、转售、获奖、虚假交易的，百度有权取消其获奖资格
                                                或其因参加活动所获权益，有权采取包括不限于停止服务、封停帐号、冻结代金券等止损和保
                                                护措施；如该违规行为给百度造成损失的，百度保留追究其民事责任和刑事责任的权利。<br/>
                                                3)活动期间，因用户操作不当或用户所在地区网络故障、电信运营商故障等非百度所能控制的
                                                原因导致用户无法参与活动或参与失败，请您联系当地电信运营商解决。<br/>
                                                4)参与本活动用户，需保证身份真实有效，且中奖用户需与活动参与人保持一致，如用户信
                                                息不一致所导致的损失由用户自行承担。<br/>
                                                5)如出现不可抗力或情势变更的情况(包括但不限于重大灾害事件、活动受政府机关指令需
                                                要停止举办或调整的、活动遭受严重网络攻击或因系统故障需要暂停举办的),则百度可依相
                                                关法律法规的规定主张免责。<br/>
                                                6)百度可根据活动的实际情况，在法律允许的范围内，对本活动规则进行变动或调整，相关
                                                变动或调整将公布在活动规则页面上，
                                                并于公布时即时生效。<br/>
                                            </div>
                                        </div>
                                    ),
                                    disabledHtml: true,
                                    okText: '确认',
                                    okClick: () => {
                                        this.confirm && this.confirm();
                                    }
                                });
                            }}
                            className="w-rules-options-details" ref={product => this.productNode = product}>
                            规则详情
                            <i className="w-icon-arrow w-icon-arrow-s"></i>
                        </span>
                        <a href="/m/activity/address" className="w-rules-options-prize">
                            <i></i>
                            我的奖品
                        </a>
                    </span>
                </div>
                <div className="w-section-title">
                    <h3 className="w-section-title-text">特惠专区</h3>
                </div>
                <div className={'srd-mod-lq'}>
                    <img
                        src={require('../../asset/image/activity/lq.png')}
                        alt=""
                        onClick={() => {
                            this.payVoucher();
                        }}
                    />
                </div>
                <div className={'news-srd-mod'}>
                    {
                        orderList.map((item, index) => {
                            return <div className="srd-item-mod" key={index}>
                                <div className="srd-item-mod-top">
                                    <div>
                                        <div className="srd-item-name">{item.service_name}</div>
                                        <div className="srd-item-type">{`${obj[item.version]} ${item.t_m}`} </div>
                                    </div>
                                    <a href="/m/product/5" target={'_blank'} className="srd-item-mod-a">产品详情</a>
                                </div>
                                <div className="srd-item-mod-m">
                                    <div>
                                        <div>{item.detail.domain}</div>
                                        <div className="srd-item-span">域名</div>
                                    </div>
                                    <div>
                                        <div>{item.detail.url}</div>
                                        <div className="srd-item-span">URL</div>
                                    </div>
                                    <div>
                                        <div>{item.detail.scan}</div>
                                        <div className="srd-item-span">扫描次数</div>
                                    </div>
                                </div>
                                <div className="srd-item-tetx">
                                    <span className={'srd-item-u'}>￥</span>
                                    <span className="srd-item-price">{item.price}</span>
                                    <img src={require('../../asset/image/activity/icon_quanhou.svg')} alt=""/>
                                    <span className="srd-item-delay">原价：{item.origin_price}</span></div>
                                <a
                                    className="srd-item-mod-bot"
                                    href={`/console/#/scan/buy/all/${item.meal_id}`}
                                    target="_blank"
                                >
                                    立即购买
                                </a>
                            </div>;
                        })
                    }
                </div>

                <div className={'srd-list-box'}>
                    <div className={'srd-list-item'}>
                        <div className={'title'}>
                            网址安全检测
                        </div>
                        <div className={'des'}>
                            <span>查询次数</span>
                            <span>50万次</span>
                        </div>
                        <div className={'text'}>
                            <span>￥</span>
                            <span>26000</span>
                            <img src={require('../../asset/image/activity/icon_quanhou.svg')} alt=""/>
                        </div>
                        <div className={'text2'}>原价：30000元/年</div>
                        <a href="/m/product/urlsec" target={'_blank'} className="srd-item-mod-a">产品详情</a>
                        <a
                            className="srd-item-mod-bot"
                            href={'/console/#/urlsec/buy'}
                            target="_blank"
                        >
                            立即购买
                        </a>
                    </div>
                    <div className={'srd-list-item'}>
                        <div className={'title'}>
                            网址安全检测
                        </div>
                        <div className={'des'}>
                            <span>查询次数</span>
                            <span>100万次</span>
                        </div>
                        <div className={'text'}>
                            <span>￥</span>
                            <span>44600</span>
                            <img src={require('../../asset/image/activity/icon_quanhou.svg')} alt=""/>
                        </div>
                        <div className={'text2'}>原价：50000元/年</div>
                        <a href="/m/product/urlsec" target={'_blank'} className="srd-item-mod-a">产品详情</a>
                        <a
                            className="srd-item-mod-bot"
                            href={'/console/#/urlsec/buy'}
                            target="_blank"
                        >
                            立即购买
                        </a>
                    </div>

                </div>


                <div className="w-section-title">
                    <h3 className="w-section-title-text">免费专区</h3>
                </div>
                <div className="w-section-product padding-top-100">
                    {serviceList
                    && serviceList.length > 0
                    && serviceList.map((item, index) => {
                        return (
                            <div key={item.service_id || index} className="w-section-product-item-wrapper">
                                <div className="item-title">
                                    <span className={cn('name', {hot: item.is_hot})}>{item.service_name}</span>
                                    {!!item.is_hot && <i className="hot-icon"></i>}
                                </div>
                                <div className="item-body">
                                    <div className="product-des">
                                        {item.service_desc}
                                    </div>
                                    <div className={'overHidden'}>
                                        <a className="product-details" href={item.url} target={'_blank'}>
                                            <span>产品详情</span>
                                            <i className="w-icon-arrow"></i>
                                        </a>
                                    </div>
                                    <div className="product-time">
                                        <span className="label">免费体验时长：</span>
                                        <span className="value">{item.capacity}</span>
                                    </div>
                                    <div
                                        onClick={this.payProduct.bind(this, item)}
                                        className={cn('product-btn', {disabled: item.is_buy})}>
                                        {item.is_buy ? '已领取' : '免费领取'}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        activityGetService: state.activityGetService,
        instanceGetinstance: state.instanceGetinstance
    }),
    dispatch => ({
        fetchInstanceGetInstance: (...args) => fetchInstanceGetInstance(dispatch, ...args),
        fetchGetNewService: (...args) => fetchGetNewService(dispatch, ...args),
        fetchApimealPay: (...args) => fetchApimealPay(dispatch, ...args)
    })
)(Activity);



// WEBPACK FOOTER //
// ./src/containers/activity/index.js